import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EventCategoriesList } from "./EventCategoriesList";
import { EventCategoryModal } from "./EventCategoryModal";

export function EventCategoriesManager() {
  const [showModal, setShowModal] = useState(false);
  const [editingCategoryId, setEditingCategoryId] = useState<string | null>(null);

  const handleEdit = (categoryId: string) => {
    setEditingCategoryId(categoryId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingCategoryId(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-xl font-semibold">Event Categories</h2>
          <p className="text-sm text-muted-foreground">
            Manage event categories used for organizing communication templates and event flows
          </p>
        </div>
        <Button onClick={() => setShowModal(true)} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add Category
        </Button>
      </div>

      <EventCategoriesList onEdit={handleEdit} />

      <EventCategoryModal
        open={showModal}
        onOpenChange={handleCloseModal}
        categoryId={editingCategoryId}
      />
    </div>
  );
}